<script>
import { GlCard } from '@gitlab/ui';

export default {
  name: 'FooterApp',
  components: { GlCard },
};
</script>

<template>
  <div class="gl-flex gl-flex-col gl-items-center">
    <gl-card v-if="$scopedSlots['card-content']" class="gl-max-w-80 gl-text-center gl-mx-7">
      <slot name="card-content"></slot>
    </gl-card>
    <div class="gl-my-7">
      <slot name="policies-content"></slot>
    </div>
  </div>
</template>
